import Vue from 'vue'
import App from './App.vue'
import router from "./router"
import ShardsVue from 'shards-vue'
import VueRouter from 'vue-router'
import 'bootstrap/dist/css/bootstrap.css'
import 'shards-ui/dist/css/shards.css'
import store from './store'
import { gapiPromise } from './gapi'

import Toasted from 'vue-toasted';
Vue.use(Toasted);

Vue.config.productionTip = false

Vue.use(ShardsVue)
Vue.use(VueRouter)

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');


(async () => {
    await gapiPromise;

    const gapi = window.gapi;

    if(gapi) {
        gapi.load('auth2', function() {
            gapi.auth2.init();
            store.commit('gapiLoaded')
        });
    }

})();



import $ from 'jquery'

$('head').append('<meta name="google-signin-client_id" content="'+process.env.VUE_APP_GOOGLE_CLIENT_ID+'">')


